import {FC, SVGProps} from 'react';

export const CloseIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
		<path d="M3.99805 3.99805L20.0004 20.0004" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
		<path d="M3.99805 20L20.0004 3.99768" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);
